import declarationTaskTracking from './view/declarationTaskTracking.html'

export default {
  base: {
    state: 'declaration.personalIncomeTax.declarationTaskTracking',
    config: {
      url: '/declarationTaskTracking',
      abstract: true,
      template: '<div ui-view></div>',
      default: 'declaration.personalIncomeTax.declarationTaskTracking.list',
      title: '申报任务跟踪',
    },
  },
  list: {
    state: 'declaration.personalIncomeTax.declarationTaskTracking.list',
    config: {
      url: '/list',
      template: declarationTaskTracking,
      controller: 'declarationTaskTrackingCtrl',
    },
  },
}



// WEBPACK FOOTER //
// ./src/app/declaration/personalIncomeTax/declarationTaskTracking/routers.js